import { Error } from './../models/error';
import { FeedbackService } from 'app/utils/feedback/feedback.service';
import { Usuario } from './../models/usuario';
import { Subscription } from 'rxjs/Rx';
import { AutenticacaoService } from './../app-services/autenticacao.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AutenticacaoGuard implements CanActivate {

  constructor(
    private autenticacaoService: AutenticacaoService,
    private router: Router,
    private _feedbackService: FeedbackService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.controlarAcesso(next, state);
  }

  private controlarAcesso(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let usuario: Usuario;
    usuario = this.autenticacaoService.usuarioAtual();
    if (usuario != null) {
      return true;
    }
    else {
      this.router.navigate([this.redirectUrl(route.params.tenantCodigo)]);
      return false;
    }
    
  }

  private redirectUrl(tenant: any): string {
    return `/${tenant != null ? tenant + "/" : ""}login`;
  }

}



// WEBPACK FOOTER //
// ./src/app/app-guards/autenticacao.guard.ts